export default __webpack_public_path__ + "static/media/Kiki's Delivery Service - A Town With An Ocean View - Main Theme.4ec9a836.mp3";